<template>
  <div v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.BOOK)" class="spl-book-consolidated">
    <subpage-header back-link="parcel-list" label="Consolidated Booking" />

    <div class="spl-edit-template__step-header-holder">
      <div class="spl-edit-template__step-header">
        <div
          v-for="(step, index) in steps"
          :key="'consolidatedBookStep' + index"
          :class="{'spl-edit-template__step-header__step-active': currentStep === index, 'spl-edit-template__step-header__step-valid': step.ref && step.ref.isValid()} "
          class="spl-edit-template__step-header__step"
          @click="showStep(index)">
          {{ step.label }}
        </div>
      </div>
    </div>

    <div class="spl-edit-template">
      <!-- *********************** STEP 1: General Information Section  *********************************** -->
      <booking-general-information
        v-show="currentStep === 0"
        ref="generalInformation"
        :next-step-label="getNextStepLabel(0)"
        :booking-data="bookingData"
        booking-type="distributed"
        @nextStep="onNextStep" />

      <!-- *********************** STEP 2: Address & Contact Section  *********************************** -->
      <booking-address
        v-show="currentStep === 1"
        ref="address"
        :next-step-label="getNextStepLabel(1)"
        :booking-data="bookingData"
        @nextStep="onNextStep" />

      <!-- *********************** STEP 3: Parcel Details Section  *********************************** -->
      <consolidated-container-details
        v-show="currentStep === 2"
        ref="parcelDetails"
        :next-step-label="getNextStepLabel(2)"
        :booking-data="bookingData"
        @nextStep="onNextStep" />

      <!-- *********************** STEP 4: Additional Information  *********************************** -->
      <booking-additional-informations
        v-show="currentStep === 3"
        ref="additionalInformations"
        :next-step-label="getNextStepLabel(4)"
        :booking-data="bookingData"
        :is-booking="isBooking"
        booking-type="distributed"
        @save="onSave"
        @cancel="onCancel" />
    </div>

    <!-- *********************** Message Modal *********************************** -->
    <message-modal />
    <!-- *********************** Book Success Modal *********************************** -->
    <parcel-book-success-modal @book_More_Clicked="book_More" @see_Consolidated_Bookings_Clicked="see_Consolidated_Bookings" />
    <div v-if="isBooking" class="spl-load-img" />
  </div>
</template>

<script>
import webApi from '@/webApi'
import Helpers from '@/helpers.vue'
import { merge } from 'lodash'
import constants from '@/constants'

export default {
  name: 'ConsolidatedBook',
  mixins: [Helpers],
  data () {
    return {
      isBooking: false,
      bookingData: {
        containerAmount: 0,
        book_parcel_model: {
          Is_Forward: true,
          Customer_ID: -1,
          Country_ID: -1,
          Service_Level_ID: -1,
          Pickup_Address_ID: -1,
          Pickup_Address: {},
          Delivery_Address_ID: -1,
          Delivery_Address: {},
          Contact: {},
          Booked_Pickup_Date: new Date(),
          Open_Deadline: '',
          Close_Deadline: '',
          Shipment_Reference: '',
          Container_Detail_List: [],
          Delivery_Information: ''
        }
      },
      currentStep: 0,
      stepElems: null,
      headerHolder: null,
      constants,
      parcelIDs: [-1],
      steps: [
        {
          ref: null,
          label: 'General Information'
        },
        {
          ref: null,
          label: 'Address Details'
        },
        {
          ref: null,
          label: 'Container Details'
        },
        {
          ref: null,
          label: 'Add Notes & Save  '
        }
      ]
    }
  },

  mounted () {
    this.steps[0].ref = this.$refs.generalInformation
    this.steps[1].ref = this.$refs.address
    this.steps[2].ref = this.$refs.parcelDetails
    this.steps[3].ref = this.$refs.additionalInformations
    if (this.$el.querySelector) {
      this.headerHolder = this.$el.querySelector('.spl-edit-template__step-header-holder')
      this.stepElems = this.$el.querySelectorAll('.spl-edit-template__step')
    }
  },
  methods: {
    // ************************ Save the parcel ************************
    onSave (bookingData) {
      this.isBooking = true
      merge(this.bookingData, bookingData)
      var createCmrModel = {
        Parcel_IDs: [],
        Create_CMR: bookingData.saveOptions.Create_CMR,
        Create_Delivery_Note: bookingData.saveOptions.Create_Delivery_Note,
        Create_Loading_List: bookingData.saveOptions.Create_Loading_List
      }

      var bookParcelModel = {
        Book_Consolidated_Parcel_Model: this.bookingData.book_parcel_model,
        Create_CMR_Model: createCmrModel,
        Send_Mail_To: bookingData.saveOptions.Email
      }

      webApi.parcel.book_Consolidated_Parcel(bookParcelModel)
        .then((response) => {
          // Open the created parcel
          var responeModel = response.data
          this.parcel_id = responeModel.Parcel_IDs[0]
          var documentId = responeModel.Document_ID
          if (documentId > 0) {
            this.downloadDocument(documentId)
            window.bus.$emit(constants.BUS_EVENTS.OPEN_BOOK_SUCCESS_MODAL, 'The parcel was booked. It might take some time to load the generated documents. They can also e found in parcel details.', constants.BUS_KEYS.BOOK_SUCCESS_MODAL_TYPE_CONSOLIDATED)
          } else {
            window.bus.$emit(constants.BUS_EVENTS.OPEN_BOOK_SUCCESS_MODAL, 'The parcel was booked.', constants.BUS_KEYS.BOOK_SUCCESS_MODAL_TYPE_CONSOLIDATED)
          }
          this.isBooking = false
        }).catch((response) => {
          window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
          this.isBooking = false
        })
    },

    onNextStep (bookingData) {
      merge(this.bookingData, bookingData)
      this.currentStep++
    },

    // ***************** Downloads CMR / Delivery Note / Loading list ******************************
    downloadDocument (documentId) {
      webApi.document.download_Document(documentId)
        .then((response) => {
          // Cypress headless fix
          if (window.Cypress) {
            return
          }
          // First look for the file name in the header
          var filename = 'CMR_' + this.parcel_id + '.pdf'

          // From the returned file stream we create a blob
          var blob = new Blob([response.data], { type: 'application/octet-stream' })

          // Open the blob to be downloaded, for  IE we need  a special way of opening it
          if (window.navigator.msSaveOrOpenBlob) { // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
            window.navigator.msSaveBlob(blob, filename)
          } else {
            var a = window.document.createElement('a')
            a.href = window.URL.createObjectURL(blob, { type: 'text/plain' })
            a.download = filename
            document.body.appendChild(a)
            a.click() // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
            document.body.removeChild(a)
          }
        }).catch((response) => {
          window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
        })
    },
    //* ************** We want to book more parcels. Move to first step, but keep the options **********************/
    book_More () {
      // Reset the steps
      this.currentStep = 0

      this.$refs.generalInformation.reset()
      this.$refs.address.reset(this.bookingData.book_parcel_model.Is_Forward)
      this.$refs.parcelDetails.reset()
      this.$refs.additionalInformations.reset()

      // Reset the parcel (but save the some options)

      if (this.bookingData.book_parcel_model.Is_Forward) {
        // Forwards parcel normally have the same pickup, but different delivery
        this.bookingData.book_parcel_model.Delivery_Address_ID = -1
        this.bookingData.book_parcel_model.Contact = {
          Active: true,
          Contact_ID: -1,
          Contact_Name: '',
          Phone_Number: ''
        }

        this.bookingData.delivery_address_object = {}
        this.bookingData.delivery_address_formatted = ''
      } else {
        // Return parcel normally have different pickup, but same delivery
        this.bookingData.book_parcel_model.Pickup_Address_ID = -1
        this.bookingData.pickup_address_object = {}
        this.bookingData.pickup_address_formatted = ''
      }
      this.bookingData.book_parcel_model.Shipment_Reference = ''
      this.parcelIDs = [-1]
      this.bookingData.book_parcel_model.Container_Detail_List = []
      this.$refs.parcelDetails.addContainer()
      this.bookingData = this.bookingData
    },

    see_Consolidated_Bookings () {
      if (this.bookingData.book_parcel_model.Shipment_Reference !== '') {
        this.$router.push('/parcel-list?search=' + this.bookingData.book_parcel_model.Shipment_Reference)
      }
    },

    // ************************ Set functions for dropdowns ************************

    // Set the service level ID from the dropdown choice
    service_level_set (item) {
      this.bookingData.book_parcel_model.Service_Level_ID = item.value
    },

    // ************************ Generate a counter number for the parcel ************************

    nextStep () {
      this.currentStep += 1
      this.scrollToHeaderStep()
    },
    scrollToHeaderStep () {
      const activeHeaderStep = this.headerHolder.querySelectorAll('.spl-edit-template__step-header__step')[this.currentStep]
      this.headerHolder.scrollLeft = activeHeaderStep.offsetLeft + activeHeaderStep.offsetWidth / 2 - window.innerWidth / 2
    },
    showStep (index) {
      if (index === 0 || this.steps[index - 1].ref.isValid()) {
        this.currentStep = index
        this.scrollToHeaderStep()
      }
    },

    onCancel () {
      this.$router.go(-1)
    },

    getNextStepLabel (step) {
      return step + 1 > this.steps.length - 1 ? 'Save' : 'Next: ' + this.steps[step + 1].label
    }
  }
}
</script>

<style lang="scss">
.spl-next-button {
  float: right;
  margin-top: 60px;
}
.spl-book-consolidated {
  & .spl-edit-template {
    margin-top: 10px;
    &__step:first-child {
      padding: 35px 70px;
    }
  }
}

</style>
